<template>
  <div class="relative overflow-hidden rounded-full">
    <label
      class="absolute inset-y-0 left-0 flex w-20 items-center justify-center border-r border-background-fg/8 bg-background-fg/3"
      for="search-input"
    >
      Search
    </label>
    <input
      id="search-input"
      :value="modelValue"
      type="search"
      enterKeyHint="search"
      :class="[
        'block w-full rounded-full border border-background-fg/8 bg-background pl-24 text-base font-semibold focus:outline-none', // Font size set at >14px (text-base) so no zoom on mobile when focused
        'focus:border-primary focus:ring-primary',
      ]"
      @input="onInput"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string
}>()
const emit = defineEmits<{
  (event: "update:modelValue", value: string): void
}>()

const onInput = (event: Event) => {
  const value_ = (event.target as HTMLInputElement)?.value
  emit("update:modelValue", value_)
}
</script>
